import { ExportColumn, ExportOptions } from '../../types';
import hasTextExportDecoration from '../hasTextExportDecoration';

// A real Boolean cell can't carry the Ano/Ne display text or a prefix/suffix,
// so those cases fall back to the text path.
const resolveXlsxCellBoolean = (
  row: Record<string, unknown>,
  column: ExportColumn,
  options: ExportOptions
): boolean | undefined => {
  if (options.useDisplayFormatting) {
    return undefined;
  }

  if (hasTextExportDecoration(column.exportOptions)) {
    return undefined;
  }

  const rawValue = row[column.name];

  // Only real booleans convert; the strings 'true' and 'false' must stay text.
  return typeof rawValue === 'boolean' ? rawValue : undefined;
};

export default resolveXlsxCellBoolean;
